export default __webpack_public_path__ + "static/media/Shadow's Legguards of the Hidden Palace.e0c2364c.jpg";